import React from 'react';
import tw, { styled } from 'twin.macro';

const NotFoundError = () => {
  return (
    <ErrorWrapper>
      <ErrorContainer>
        <img src="/static/images/logo/formplus-logo.png" id="formplus-logo" alt="Formplus Logo" width="85px" />
        <div>
          <img src="https://storage.googleapis.com/fplsblog/404_NOT_FOUND.png" alt="404" />
        </div>
        <p>It seems this page doesn't exist</p>
        <a id='hompage' href="/">Go to Homepage</a>
        <hr />
        <a id="support" href="https://help.formpl.us/s/contactsupport" target="_blank">Talk to support</a>
      </ErrorContainer>
    </ErrorWrapper>
  );
};

export default NotFoundError;

export const ErrorWrapper = styled.div`
  ${tw`fixed top-0 left-0 w-full h-full overflow-auto flex flex-col items-center justify-center`};
  height: 100%;
  z-index: 1500;
`;

export const ErrorContainer = styled.div`
  ${tw`flex flex-col justify-center text-center p-10 max-w-2xl`};

  > #formplus-logo {
    position: absolute;
    top: 20px;
    left: 20px;
  }

  > p {
    margin-top: 40px;
    font-size: 17px;
    font-weight: 500;
  }

  > a#hompage {
    ${tw`mx-auto py-3 px-11 text-white no-underline block`};
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    color: white !important;
    width: fit-content;
    background: rgb(26, 140, 175);
    background: linear-gradient(to left top, #00afbf, #1a8caf);

    &:hover {
      background: linear-gradient(to right bottom, #00afbf, #1a8caf);
    }
  }

  hr {
    border: 1px solid #eee;
    margin: 40px 0;
    widht: 100%;
  }

  > a#support {
    ${tw`-underline`};
    color: #1a8caf;
    font-size: 14px;
    font-weight: 600;
  }
`;
